import * as React from 'react';
import { AccentDialog } from '../../dialogs/AccentDialog';
import { AccentButton } from '../AccentButton';
import { AccentTextUnbound } from '../unbound/AccentTextUnBound';
import { AccentTextAreaUnbound } from '../unbound/AccentTextAreaUnbound';
import { accentUtils, t } from '../../services/HelperService';

/**
 * Small name/description prompt used when saving an assistant artifact as a new
 * Customization. Resolves { name, description } or { canceled: true }.
 */
export const SaveCustomizationDlg = ({ onClose, initialName = '', initialDescription = '', headerContent = null, saveButtonText = null }) => {
  const [name, setName] = React.useState(initialName ?? '');
  const [description, setDescription] = React.useState(initialDescription ?? '');
  const [error, setError] = React.useState(null);

  const save = (e) => {
    const trimmedName = (name ?? '').trim();
    if (accentUtils.isEmpty(trimmedName)) {
      setError(t('Name is required.'));
      e.promise();
      return;
    }

    onClose?.({
      name: trimmedName,
      description: (description ?? '').trim(),
    });
    e.promise();
  };

  return (
    <AccentDialog
      headerContent={headerContent ?? t('Save Customization')}
      onClose={onClose}
      minWidth={480}
      maxWidth={720}
      actionsContent={[
        <AccentButton key="save" tagName="save" onClick={save}>
          {saveButtonText ?? t('Save')}
        </AccentButton>,
      ]}
    >
      <div style={{ display: 'grid', gap: 12 }}>
        {!!error && (
          <div className="alert alert-danger" style={{ marginBottom: 0 }}>
            {error}
          </div>
        )}
        <AccentTextUnbound
          label={t('Name')}
          required
          onChange={setName}
          defaultValue={initialName}
          maxLength={255}
        />
        <AccentTextAreaUnbound
          label={t('Description')}
          rows={3}
          max={2000}
          onChange={setDescription}
          defaultValue={initialDescription}
          style={{ width: '100%' }}
        />
      </div>
    </AccentDialog>
  );
};
